var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItemStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91675 4.33398C2.91675 3.7817 3.36446 3.33398 3.91675 3.33398H7.9823C8.24379 3.33398 8.49489 3.43641 8.68177 3.61932L10.3525 5.25453C10.5394 5.43744 10.7905 5.53987 11.052 5.53987H16.0834C16.6357 5.53987 17.0834 5.98758 17.0834 6.53987V14.834C17.0834 15.3863 16.6357 15.834 16.0834 15.834H3.91675C3.36446 15.834 2.91675 15.3863 2.91675 14.834V4.33398Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 11.667H15",
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemStatus);
export default __webpack_public_path__ + "static/media/item-status.1076fdb8761a46d1a2af6ce700f96b69.svg";
export { ForwardRef as ReactComponent };